const config = {
  apiGateway: {
    REGION: 'ap-southeast-1',
    INTERNAL_API_URL: 'https://n987j7bom8.execute-api.ap-southeast-1.amazonaws.com/prod',
    COMPANY_API_URL: 'https://v8gvy8zyd6.execute-api.ap-southeast-1.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'taxonomy-company-1.13.4',
    HOSTNAME: 'https://company.staging.oceanagold.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.staging.oceanagold.forwoodsafety.com',
    WEBSOCKET: 'wss://auduqo2dzb.execute-api.ap-southeast-1.amazonaws.com/staging'
  },
};

export default config;